import userApi from '@/common/api/user.api';
import Vue from 'vue';
import VueRouter from 'vue-router';
// import  { ModuleConstant }  from '@/common/util/module-constant';
import { eventHub } from '@/main';

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'Home',
		component: () =>
			import(/* webpackChunkName: "home" */ '@/layouts/Home.vue'),
		children: [
			{
				path: '/login',
				name: 'AppLogin',
				component: () =>
					import(
						/* webpackChunkName: "login" */ '../views/access/AppLogin.vue'
					),
			},
			{
				path: '/login/:clientSlug',
				name: 'LoginSlug',
				component: () =>
					import(
						/* webpackChunkName: "login-slug" */ '../views/access/AppLogin.vue'
					),
			},
			{
				path: '/solicitar-senha',
				name: 'ForgotPassword',
				component: () =>
					import(
						/* webpackChunkName: "forgot-password" */ '../views/access/ForgotPassword.vue'
					),
			},
			{
				path: '/lembrar-conta',
				name: 'RememberAccount',
				component: () =>
					import(
						/* webpackChunkName: "remember-account" */ '../views/access/RememberAccount.vue'
					),
			},
			{
				path: '/redefinir-senha/:token/:clientSlug',
				name: 'ResetPassword',
				component: () =>
					import(
						/* webpackChunkName: "reset-password" */ '../views/access/ResetPassword.vue'
					),
			},
			{
				path: '/',
				redirect: '/login',
			},
		],
	},
	{
		path: '/publico',
		name: 'Public',
		component: () =>
			import(/* webpackChunkName: "public" */ '@/layouts/Public.vue'),
		children: [
			{
				path: '/dispositivo/busca/:serialNumber',
				name: 'PublicDeviceDetails',
				component: () =>
					import(
						/* webpackChunkName: "public-device-details" */ '../views/device/PublicDeviceDetails.vue'
					),
			},
			{
				path: '/',
				redirect: { name: 'PublicDeviceDetails' },
			},
		],
	},
	{
		path: '/painel-brigadista',
		component: () =>
			import(/* webpackChunkName: "safety" */ '@/layouts/Safety.vue'),
		children: [
			{
				path: ':placeId/home',
				name: 'SafetyWelcome',
				component: () =>
					import(
						/* webpackChunkName: "safety-welcome" */ '../views/safety/SafetyWelcome.vue'
					),
			},
			{
				path: ':placeId/help',
				name: 'SafetyHelp',
				component: () =>
					import(
						/* webpackChunkName: "safety-help" */ '../views/safety/SafetyHelp.vue'
					),
			},
			{
				path: ':placeId/busca/matricula',
				name: 'SafetyRegistrationInput',
				component: () =>
					import(
						/* webpackChunkName: "safety-registration-input" */ '../views/safety/RegistrationInput.vue'
					),
			},
			{
				path: ':placeId/busca/face',
				name: 'SafetyFaceInput',
				component: () =>
					import(
						/* webpackChunkName: "safety-face-input" */ '../views/safety/FaceInput.vue'
					),
			},
			{
				path: ':placeId/busca/resultado',
				name: 'SafetySearchResult',
				component: () =>
					import(
						/* webpackChunkName: "safety-search-result" */ '../views/safety/SearchResult.vue'
					),
			},
			{
				path: ':placeId/busca/resultado/sucesso',
				name: 'SafetySearchSuccess',
				component: () =>
					import(
						/* webpackChunkName: "safety-search-success" */ '../views/safety/SearchSuccess.vue'
					),
			},
			{
				path: ':placeId/busca/resultado/erro',
				name: 'SafetySearchError',
				component: () =>
					import(
						/* webpackChunkName: "safety-search-error" */ '../views/safety/SearchError.vue'
					),
			},
			{
				path: '/',
				redirect: '/painel-brigadista/home',
			},
		],
	},
	{
		path: '/',
		component: () =>
			import(/* webpackChunkName: "private" */ '@/layouts/Private.vue'),
		children: [
			{
				path: '/modulos',
				name: 'ModuleSelection',
				component: () =>
					import(
						/* webpackChunkName: "module-selection" */ '../views/dashboard/ModuleSelection.vue'
					),
			},
			{
				path: '/home',
				name: 'SmartSafetyDashboard',
				// beforeEnter: authGuard,
				// meta: {
				// 	Module: [ModuleConstant.Module.SmartSafety]
				// },
				component: () =>
					import(
						/* webpackChunkName: "smart-safety-dashboard" */ '../views/dashboard/SmartSafetyDashboard.vue'
					),
			},
			{
				path: '/dashboard/vision',
				name: 'VisionDashboard',
				// beforeEnter: authGuard,
				// meta: {
				// 	Module: [ModuleConstant.Module.Vision]
				// },
				component: () =>
					import(
						/* webpackChunkName: "vision-dashboard" */ '../views/dashboard/VisionDashboard.vue'
					),
			},
			{
				path: '/vision/monitorar/cameras',
				name: 'MonitoringCameraList',
				component: () =>
					import(
						/* webpackChunkName: "monitoring-camera-list" */ '../views/vision/monitor/MonitoringCameraList.vue'
					),
			},
			{
				path: '/dispositivos',
				name: 'DeviceList',
				component: () =>
					import(
						/* webpackChunkName: "device-list" */ '../views/device/DeviceList.vue'
					),
			},
			{
				path: '/dispositivos/lote',
				name: 'DeviceAddBulk',
				component: () =>
					import(
						/* webpackChunkName: "device-add-bulk" */ '../views/device/bulk/DeviceAddBulk.vue'
					),
			},
				{
				path: '/dispositivos/lote/update',
				name: 'DeviceBulkUpdate',
				component: () =>
					import(
						/* webpackChunkName: "device-add-bulk" */ '../views/device/bulk/DeviceBulkUpdate.vue'
					),
			},
			{
				path: '/dispositivos/:deviceId',
				name: 'DeviceDetails',
				component: () =>
					import(
						/* webpackChunkName: "device-details" */ '../views/device/DeviceDetails.vue'
					),
			},
			{
				path: '/dispositivos/:deviceId/maintenance',
				name: 'DeviceDetails',
				component: () =>
					import(
						/* webpackChunkName: "device-details" */ '../views/device/device-maintenance/DeviceMaintenanceList.vue'
					),
			},
			{
				path: '/colaboradores',
				name: 'EmployeeList',
				component: () =>
					import(
						/* webpackChunkName: "employee-list" */ '../views/employee/EmployeeList.vue'
					),
			},
			{
				path: '/colaboradores/lote',
				name: 'EmployeeAddBulk',
				component: () =>
					import(
						/* webpackChunkName: "employee-add-bulk" */ '../views/employee/bulk/EmployeeAddBulk.vue'
					),
			},
			{
				path: '/colaboradores/:employeeId',
				name: 'EmployeeDetails',
				component: () =>
					import(
						/* webpackChunkName: "employee-details" */ '../views/employee/EmployeeDetails.vue'
					),
			},
			{
				path: '/equipamentos',
				name: 'EquipmentList',
				component: () =>
					import(
						/* webpackChunkName: "equipment-list" */ '../views/equipment/EquipmentList.vue'
					),
			},
			{
				path: '/equipamentos/lote',
				name: 'EquipmentAddBulk',
				component: () =>
					import(
						/* webpackChunkName: "equipment-add-bulk" */ '../views/equipment/bulk/EquipmentAddBulk.vue'
					),
			},
			{
				path: '/equipamentos/:equipmentId',
				name: 'EquipmentDetails',
				component: () =>
					import(
						/* webpackChunkName: "equipment-details" */ '../views/equipment/EquipmentDetails.vue'
					),
			},
			{
				path: '/ambientes',
				name: 'PlaceList',
				component: () =>
					import(
						/* webpackChunkName: "place-list" */ '../views/place/PlaceList.vue'
					),
			},
			{
				path: '/ambientes/:placeId',
				name: 'PlaceDetails',
				component: () =>
					import(
						/* webpackChunkName: "place-details" */ '../views/place/PlaceDetails.vue'
					),
			},
			{
				path: '/contas',
				name: 'ClientList',
				component: () =>
					import(
						/* webpackChunkName: "client-list" */ '../views/client/ClientList.vue'
					),
			},
			{
				path: '/contas/:clientId',
				name: 'ClientDetails',
				component: () =>
					import(
						/* webpackChunkName: "client-details" */ '../views/client/ClientDetails.vue'
					),
			},
			{
				path: '/contas/:clientId/contratos',
				name: 'ContractList',
				component: () =>
					import(
						/* webpackChunkName: "contract-list" */ '../views/client/ContractList.vue'
					),
			},
			{
				path: '/contas/:clientId/contratos/:contractId',
				name: 'ContractDetails',
				component: () =>
					import(
						/* webpackChunkName: "contract-details" */ '../views/client/ContractDetails.vue'
					),
			},
			{
				path: '/perfil',
				name: 'ClientProfile',
				component: () =>
					import(
						/* webpackChunkName: "client-details" */ '../views/client/ClientDetails.vue'
					),
			},
			{
				path: '/usuarios',
				name: 'UserList',
				component: () =>
					import(
						/* webpackChunkName: "user-list" */ '../views/user/UserList.vue'
					),
			},
			{
				path: '/usuarios/:userId',
				name: 'UserDetails',
				component: () =>
					import(
						/* webpackChunkName: "user-details" */ '../views/user/UserDetails.vue'
					),
			},
			{
				path: '/produtos',
				name: 'ProductList',
				component: () =>
					import(
						/* webpackChunkName: "product-list" */ '../views/product/ProductList.vue'
					),
			},
			{
				path: '/produtos/:productId',
				name: 'ProductDetails',
				component: () =>
					import(
						/* webpackChunkName: "product-details" */ '../views/product/ProductDetails.vue'
					),
			},
			{
				path: '/grupos-permissao',
				name: 'PermissionGroupList',
				component: () =>
					import(
						/* webpackChunkName: "permission-group-list" */ '../views/permission-group/PermissionGroupList.vue'
					),
			},
			{
				path: '/grupos-permissao/:permissionGroupId',
				name: 'PermissionGroupDetails',
				component: () =>
					import(
						/* webpackChunkName: "permission-group-details" */ '../views/permission-group/PermissionGroupDetails.vue'
					),
			},
			{
				path: '/relatorios',
				name: 'ReportsList',
				component: () =>
					import(
						/* webpackChunkName: "reports" */ '../views/report/ReportsList.vue'
					),
			},
			{
				path: '/integracoes',
				name: 'IntegrationList',
				component: () =>
					import(
						/* webpackChunkName: "integration-list" */ '../views/integration/IntegrationList.vue'
					),
			},
			{
				path: '/integracoes/:integrationId',
				name: 'IntegrationDetails',
				component: () =>
					import(
						/* webpackChunkName: "integration-details" */ '../views/integration/IntegrationDetails.vue'
					),
			},
			{
				path: '/tipos-log',
				name: 'LogTypeList',
				component: () =>
					import(
						/* webpackChunkName: "log-type-list" */ '../views/log-type/LogTypeList.vue'
					),
			},
			{
				path: '/tipos-log/:logTypeId',
				name: 'LogTypeDetails',
				component: () =>
					import(
						/* webpackChunkName: "log-type-details" */ '../views/log-type/LogTypeDetails.vue'
					),
			},
			{
				path: '/zonemaps',
				name: 'ZoneMapList',
				component: () =>
					import(
						/* webpackChunkName: "zone-map-list" */ '../views/zone-map/ZoneMapList.vue'
					),
			},
			{
				path: '/zonemaps/monitoramento',
				name: 'ZoneMapMonitoring',
				component: () =>
					import(
						/* webpackChunkName: "zone-map-monitoring" */ '../views/zone-map/ZoneMapMonitoring.vue'
					),
			},
			{
				path: '/sinoptico',
				name: 'SynopticView',
				component: () =>
					import(
						/* webpackChunkName: "synoptic-view" */ '../views/synoptic/SynopticView.vue'
					),
			},
			{
				path: '/sinoptico_analitico',
				name: 'SynopticView',
				component: () =>
					import(
						/* webpackChunkName: "synoptic-view" */ '../views/synoptic_analytic/SynopticAnalyticView.vue'
					),
			},
			{
				path: '/gestao-painel-brigadista',
				name: 'BrigadierPanelList',
				component: () =>
					import(
						/* webpackChunkName: "brigadier-panel-list" */ '../views/brigadier-panel/BrigadierPanelList.vue'
					),
			},
			{
				path: '/gestao-painel-brigadista/monitoramento',
				name: 'BrigadierPanelMonitoring',
				component: () =>
					import(
						/* webpackChunkName: "brigadier-panel-monitoring" */ '../views/brigadier-panel/BrigadierPanelMonitoring.vue'
					),
			},
			{
				path: '/help',
				name: 'HelpCenter',
				component: () =>
					import(/* webpackChunkName: "help" */ '../views/help/HelpCenter.vue'),
			},
			{
				path: '/insights',
				name: 'InsightsList',
				component: () =>
					import(
						/* webpackChunkName: "insight-list" */ '../views/insight/InsightsList.vue'
					),
			},
			{
				path: '/insights/:insightId',
				name: 'InsightViewer',
				component: () =>
					import(
						/* webpackChunkName: "insight-viewer" */ '../views/insight/InsightViewer.vue'
					),
			},
			{
				path: '/actions',
				name: 'ActionList',
				component: () =>
					import(
						/* webpackChunkName: "action-list" */ '../views/action/ActionList.vue'
					),
			},
			{
				path: '/actions/:actionId',
				name: 'ActionDetails',
				component: () =>
					import(
						/* webpackChunkName: "action-details" */ '../views/action/ActionDetails.vue'
					),
			},
			{
				path: '/firmwares',
				name: 'FirmwareList',
				component: () =>
					import(
						/* webpackChunkName: "firmware-list" */ '../views/firmware/FirmwareList.vue'
					),
			},
			{
				path: '/firmwares/:firmwareId',
				name: 'FirmwareDetails',
				component: () =>
					import(
						/* webpackChunkName: "firmware-details" */ '../views/firmware/FirmwareDetails.vue'
					),
			},
			{
				path: '/boards',
				name: 'BoardList',
				component: () =>
					import(
						/* webpackChunkName: "board-list" */ '../views/board/BoardList.vue'
					),
			},
			{
				path: '/boards/:boardId',
				name: 'BoardDetails',
				component: () =>
					import(
						/* webpackChunkName: "board-details" */ '../views/board/BoardDetails.vue'
					),
			},
			{
				path: '/tags',
				name: 'TagList',
				component: () =>
					import(/* webpackChunkName: "tag-list" */ '../views/tag/TagList.vue'),
			},
			{
				path: '/tags/:tagId',
				name: 'TagDetails',
				component: () =>
					import(
						/* webpackChunkName: "tag-details" */ '../views/tag/TagDetails.vue'
					),
			},
			{
				path: '/esquemas-log',
				name: 'LogSchemaList',
				component: () =>
					import(
						/* webpackChunkName: "log-schema-list" */ '../views/log-schema/LogSchemaList.vue'
					),
			},
			{
				path: '/esquemas-log/:logSchemaId',
				name: 'LogSchemaDetails',
				component: () =>
					import(
						/* webpackChunkName: "log-schema-details" */ '../views/log-schema/LogSchemaDetails.vue'
					),
			},
			{
				path: '/monitoramento',
				name: 'MonitoringList',
				component: () =>
					import(
						/* webpackChunkName: "monitoring-list" */ '../views/monitoring/MonitoringList.vue'
					),
			},
			{
				path: '/monitoramento/dashboard',
				name: 'MonitoringDashboard',
				component: () =>
					import(
						/* webpackChunkName: "monitoring-dashboard" */ '../views/monitoring/MonitoringDashboard.vue'
					),
			},
			{
				path: '/vision/monitor/camera/live',
				name: 'LiveCamera',
				component: () =>
					import(
						/* webpackChunkName: "live-camera" */ '../views/vision/camera/liveCamera/LiveCameraView.vue'
					),
			},
			{
				path: '/vision/monitorar/mosaico/cameras',
				name: 'MonitoringMosaicCamera',
				component: () =>
					import(
						/* webpackChunkName: "monitoring-mosaic-camera" */ '../views/vision/monitor/mosaic/MonitoringMosaicCamera.vue'
					),
			},
			{
				path: '/vision/monitorar/camera/live/:cameraId',
				name: 'LiveCamera',
				component: () =>
					import(
						/* webpackChunkName: "live-camera" */ '../views/vision/camera/liveCamera/LiveCameraView.vue'
					),
			},
			{
				path: '/vision/engines',
				name: 'EngineList',
				component: () =>
					import(
						/* webpackChunkName: "engine-list" */ '../views/engine/EngineListView.vue'
					),
			},
			{
				path: '/engine/details/:engineId',
				name: 'EngineDetails',
				component: () =>
					import(
						/* webpackChunkName: "engine-details" */ '../views/engine/EngineDetailsView.vue'
					),
			},
			{
				path: '/engine/new',
				name: 'EngineNew',
				component: () =>
					import(
						/* webpackChunkName: "engine-new" */ '../views/engine/EngineDetailsView.vue'
					),
			},
			{
				path: '/vision/cameras',
				name: 'CameraList',
				// beforeEnter: authGuard,
				// meta: {
				// 	Module: [ModuleConstant.Module.Vision]
				// },
				component: () =>
					import(
						/* webpackChunkName: "camera-list" */ '../views/vision/camera/cameraList/CameraListView.vue'
					),
			},
			{
				path: '/vision/camera/details',
				name: 'CameraDetails',
				// beforeEnter: authGuard,
				// meta: {
				// 	Module: [ModuleConstant.Module.Vision]
				// },
				component: () =>
					import(
						/* webpackChunkName: "camera-details" */ '../views/vision/camera/cameraDetails/CameraDetailsView.vue'
					),
			},
			{
				path: '/vision/camera',
				name: 'CameraDetails',
				// beforeEnter: authGuard,
				// meta: {
				// 	Module: [ModuleConstant.Module.Vision]
				// },
				component: () =>
					import(
						/* webpackChunkName: "camera-details" */ '../views/vision/camera/cameraDetails/CameraDetailsView.vue'
					),
			},
			{
				path: '/vision/camera/:cameraId',
				name: 'CameraDetails',
				// beforeEnter: authGuard,
				// meta: {
				// 	Module: [ModuleConstant.Module.Vision]
				// },
				component: () =>
					import(
						/* webpackChunkName: "camera-details" */ '../views/vision/camera/cameraDetails/CameraDetailsView.vue'
					),
			},
			{
				path: '/vision/camera/:cameraId/engine',
				name: 'CameraEngineList',
				// beforeEnter: authGuard,
				// meta: {
				// 	Module: [ModuleConstant.Module.Vision]
				// },
				component: () =>
					import(
						/* webpackChunkName: "camera-details" */ '../views/vision/camera/cameraEngineList/CameraEngineList.vue'
					),
			},
			{
				path: '/vision/camera/:cameraId/engine/:engineId',
				name: 'CameraEngineDetails',
				// beforeEnter: authGuard,
				// meta: {
				// 	Module: [ModuleConstant.Module.Vision]
				// },
				component: () =>
					import(
						/* webpackChunkName: "camera-details" */ '../views/vision/camera/cameraEngineDetails/CameraEngineDetails.vue'
					),
			},
		],
	},
];

const router = new VueRouter({
	routes,
});

router.beforeEach((to, from, next) => {
	eventHub.$emit('HIDE_MENU', false);

	const user = userApi.getCurrentUser();
	const publicPath = to.matched.find(
		(path) => path.name === 'Public' || path.name === 'Home'
	);

	if (!user && to.path !== '/login' && !publicPath) {
		next({
			path: '/login',
		});
	} else {
		next();
	}

	// if(user && userApi.getAppModule() && userApi.isVisionModule() && !userApi.canAccessModule(to.matched)) {
	// 	next()
	// }

	if (
		userApi.isVisionModule() &&
		userApi.canAccessModule(to.matched) &&
		to.path == '/home'
	) {
		next({
			path: '/dashboard/vision',
		});
	}
	if (
		!userApi.isVisionModule() &&
		userApi.canAccessModule(to.matched) &&
		to.path == '/dashboard/vision'
	) {
		next({
			path: '/home',
		});
	}
});

// function authGuard(to, from, next) {
// 	const user = userApi.getCurrentUser();

// 	if(user && userApi.getAppModule() && userApi.isVisionModule()) {
// 		if(!userApi.canAccessModule(to.matched)) {
// 			next({
// 				path: '/dashboard/vision'
// 			})
// 		}else {
// 			next();
// 		}
// 	}
// const publicPath = to.matched.find(
// 	(path) => path.path === '/dashboard/vision' || path.path === '/home'
// );
// console.log('publicPath', publicPath.meta.Module)
// console.log('to.matched', to.matched)

// if(user && userApi.getAppModule() && userApi.isSmartSafetyModule()) {
// 	console.log('userApi.isSmartSafetyModule()', userApi.isSmartSafetyModule())
// 	console.log('!userApi.canAccessModule(to.matched)', !userApi.canAccessModule(to.matched))
// 	if(!userApi.canAccessModule(to.matched)) {
// 		next({
// 			path: '/home'
// 		})
// 	} else {
// 		next();
// 	}
// }

// }

export default router;
